import path from 'path'

let api = {};
debugger
let modules = require.context('', true, /.js$/);
modules.keys().forEach(key => {
    const config = modules(key).default
    const name = path.basename(key, path.extname(key))
    if (name != 'index' && name != 'axios-factory') {
        api[name] = config
    }

})
export default api